export enum ReasonIsNotEligible
{
    Ok = 0,
    NoPromotionsFound = 101,
    NoSegmentationFound = 102,
    PromotionRestricted = 103,
    FTD0 = 104,
    NotDepositedInLast30Days = 105,
    SpinAlreadyUsedToday = 106
}

export interface CheckEligibilityResponse {
    isEligible: boolean;
    nextEligibleDate: string;
    reasonIsNotEligible: ReasonIsNotEligible;
    isLastEligibleDay: boolean;
    nextEligibilitySeconds: number;
    segmentationId: number;
}

export interface ICrmSdkLib {
    initCrm(params: {userToken: string}): Promise<void>;
    onConnectedToFirebase(params: {fbToken: string}): Promise<void>;
    onDisconnectedFromFirebase(): void;
    checkEligibility(): Promise<CheckEligibilityResponse>;
}
